import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { sanitizeHref, URLS } from '@wix/da-url';

import { STRIPE_CONNECT_TERMS_URL } from '../../modals/consts';
import s from './StripePaymentTerms.scss';

export interface Props {
  className?: string;
}

const StripePaymentTerms: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={s['terms']}>
        {t('studio.earnings.stripe.withdraw.modal.finePrint.terms.prefix')}{' '}
        <a
          href={URLS.TOS}
          className="text-link-level-2-secondary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('studio.earnings.stripe.withdraw.modal.finePrint.terms.deviantart')}
        </a>
        {t('studio.earnings.stripe.withdraw.modal.finePrint.terms.and')}{' '}
        <a
          href={sanitizeHref(STRIPE_CONNECT_TERMS_URL)}
          className="text-link-level-2-secondary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('studio.earnings.stripe.withdraw.modal.finePrint.terms.stripe')}
        </a>
        .
      </div>
    </div>
  );
};

StripePaymentTerms.displayName = 'StripePaymentTerms';

export default StripePaymentTerms;
